var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.755622 11.1313C0.265497 12.6669 5.95813e-05 14.3027 0.000122081 16.0009C5.95813e-05 17.6989 0.265497 19.3348 0.755685 20.8704L16.0001 21.5662L31.2445 20.8704C31.7346 19.3348 32.0001 17.6989 32.0001 16.0009C32.0001 14.3028 31.7346 12.6669 31.2445 11.1313L16.0001 10.4357L0.755622 11.1313Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0009C32 15.0518 31.9169 14.122 31.7583 13.2183H0.24175C0.083125 14.122 0 15.0516 0 16.0009C0 16.9501 0.0831875 17.8797 0.24175 18.7835H31.7583C31.9168 17.8797 32 16.9501 32 16.0009Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.001C23.1386 32.001 29.1842 27.3258 31.2444 20.8705H0.755615C2.81593 27.3257 8.86162 32.0009 16.0001 32.001V32.001Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0010376C8.86156 0.0010376 2.81593 4.67622 0.755493 11.1313L31.2442 11.1314C29.1841 4.67623 23.1384 0.0009126 16 0.0010376V0.0010376Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBw);
export default __webpack_public_path__ + "static/media/BW.e63d9230.svg";
export { ForwardRef as ReactComponent };